import { isMonitoredAssetSecurity } from '@src/components/AutoHedging/crossAssetRiskGroup';
import { getPositionAmount, POSITION_SUB_ACCOUNT, type Currency, type Security } from '@talos/kyoko';
import { compact, uniq } from 'lodash-es';

export function getCurrentPositionSubscriptionRequest(
  asset: string,
  account: string,
  securitiesBySymbol: Map<string, Security>,
  currenciesBySymbol: Map<string, Currency>
) {
  const isSecurity = isMonitoredAssetSecurity(asset, securitiesBySymbol, currenciesBySymbol);
  return {
    name: POSITION_SUB_ACCOUNT,
    tag: 'PositionAutoHedgingCard',
    SubAccount: account,
    ...(isSecurity ? { Symbols: [asset] } : { Currencies: [asset] }),
  };
}

export function getMonitoredPositionAmount(
  amount: string,
  asset: string,
  securitiesBySymbol: Map<string, Security>,
  currenciesBySymbol: Map<string, Currency>
): { value: string; currency: string } | undefined {
  const security = isMonitoredAssetSecurity(asset, securitiesBySymbol, currenciesBySymbol)
    ? securitiesBySymbol.get(asset)
    : undefined;
  if (!security) {
    return { value: amount, currency: asset };
  }

  const { value, currency } = getPositionAmount(amount, security);
  if (!currency) {
    return undefined;
  }
  return { value, currency };
}

export function getMonitoredPositionCurrency(
  asset: string,
  securitiesBySymbol: Map<string, Security>,
  currenciesBySymbol: Map<string, Currency>
): string | undefined {
  return getMonitoredPositionAmount('0', asset, securitiesBySymbol, currenciesBySymbol)?.currency;
}

export function getPositionCardCurrencyOptions(
  targetAsset: string | undefined,
  asset: string | undefined,
  securitiesBySymbol: Map<string, Security>,
  currenciesBySymbol: Map<string, Currency>
): string[] {
  return compact(
    uniq([targetAsset, asset ? getMonitoredPositionCurrency(asset, securitiesBySymbol, currenciesBySymbol) : undefined])
  );
}
